import NetworkApi from "../../data/network/NetworkApi";
import NetworkApiImpl from "../../data/network/NetworkApiImpl";
import { AnswerRepository } from "../../data/repository/answer/AnswerRepository";
import { AnswerRepositoryImpl } from "../../data/repository/answer/AnswerRepositoryImpl";
import { AuthRepository } from "../../data/repository/auth/AuthRepository";
import { AuthRepositoryImpl } from "../../data/repository/auth/AuthRepositoryImpl";
import { CategoryRepository } from "../../data/repository/category/CategoryRepository";
import { CategoryRepositoryImpl } from "../../data/repository/category/CategoryRepositoryImpl";
import { DiscountCodeRepository } from "../../data/repository/discountCode/DiscountCodeRepository";
import { DiscountCodeRepositoryImpl } from "../../data/repository/discountCode/DiscountCodeRepositoryImpl";
import { GameRepository } from "../../data/repository/game/GameRepository";
import { GameRepositoryImpl } from "../../data/repository/game/GameRepositoryImpl";
import { PackageRepository } from "../../data/repository/package/PackageRepository";
import { PackageRepositoryImpl } from "../../data/repository/package/PackageRepositoryImpl";
import { PaymentRepository } from "../../data/repository/payment/PaymentRepository";
import { PaymentRepositoryImpl } from "../../data/repository/payment/PaymentRepositoryImpl";
import { PlayerRepository } from "../../data/repository/player/PlayerRepository";
import { PlayerRepositoryImpl } from "../../data/repository/player/PlayerRepositoryImpl";
import { QRCodeRepository } from "../../data/repository/qrcode/QRCodeRepository";
import { QRCodeRepositoryImpl } from "../../data/repository/qrcode/QRCodeRepositoryImpl";
import { QuestionRepository } from "../../data/repository/question/QuestionRepository";
import { QuestionRepositoryImpl } from "../../data/repository/question/QuestionRepositoryImpl";
import { TransactionRepository } from "../../data/repository/transaction/TransactionRepository";
import { TransactionRepositoryImpl } from "../../data/repository/transaction/TransactionRepositoryImpl";
import { UploadFileRepository } from "../../data/repository/uploadFIle/UploadFileRepository";
import { UploadFileRepositoryImpl } from "../../data/repository/uploadFIle/UploadFileRepositoryImpl";
import { DiscountCode } from "../../domain/model/DiscountCode";
import {
  GetAnswerUseCase,
  GetAnswerUseCaseImpl,
} from "../../domain/usecase/answer/get/GetUseCase";

import {
  GetAnswerByQuestionIdUseCase,
  GetAnswerByQuestionIdUseCaseImpl,
} from "../../domain/usecase/answer/getByQuestionId/GetByQuestionIdUseCase";
import {
  CheckVerificationCodeUseCase,
  CheckVerificationCodeUseCaseImpl,
} from "../../domain/usecase/auth/CheckVerificationCode/UseCase";
import {
  ForgotPasswordUseCase,
  ForgotPasswordUseCaseImpl,
} from "../../domain/usecase/auth/ForgotPassword/UseCase";
import {
  LoginUseCase,
  LoginUseCaseImpl,
} from "../../domain/usecase/auth/Login/LoginUseCase";
import {
  LoginAsGuestUseCase,
  LoginAsGuestUseCaseImpl,
} from "../../domain/usecase/auth/LoginAsGuest/UseCase";
import {
  LoginByUIDUseCase,
  LoginByUIDUseCaseImpl,
} from "../../domain/usecase/auth/LoginByUID/UseCase";
import {
  ResetPasswordUseCase,
  ResetPasswordUseCaseImpl,
} from "../../domain/usecase/auth/ResetPassword/UseCase";
import {
  SendVerificationCodeUseCase,
  SendVerificationCodeUseCaseImpl,
} from "../../domain/usecase/auth/SendVerificationCode/UseCase";
import {
  SignupUseCase,
  SignupUseCaseImpl,
} from "../../domain/usecase/auth/Signup/SignupUseCase";

import {
  GetAllCategoriesUseCase,
  GetAllCategoriesUseCaseImpl,
} from "../../domain/usecase/category/getAll/GetAllUseCase";
import {
  GetCategoryUnlockCodeUseCase,
  GetCategoryUnlockCodeUseCaseImpl,
} from "../../domain/usecase/category/getUnlockCode/UseCase";
import {
  UnlockCategoryUseCase,
  UnlockCategoryUseCaseImpl,
} from "../../domain/usecase/category/unlock/UseCase";
import {
  CheckDiscountCodeIfRedeemableUseCase,
  CheckDiscountCodeIfRedeemableUseCaseImpl,
} from "../../domain/usecase/discountCode/checkIfRedeemable/UseCase";
import {
  RedeemDiscountCodeUseCase,
  RedeemDiscountCodeUseCaseImpl,
} from "../../domain/usecase/discountCode/redeem/UseCase";
import {
  UpdateGameUseCase,
  UpdateGameUseCaseImpl,
} from "../../domain/usecase/game/update/UseCase";
import {
  GetAllPackagesUseCase,
  GetAllPackagesUseCaseImpl,
} from "../../domain/usecase/package/getAll/GetAllUseCase";
import {
  ExecutePaymentUseCase,
  ExecutePaymentUseCaseImpl,
} from "../../domain/usecase/payment/execute/UseCase";
import {
  InitiatePaymentUseCase,
  InitiatePaymentUseCaseImpl,
} from "../../domain/usecase/payment/initiate/UseCase";
import {
  GetPaymentStatusUseCase,
  GetPaymentStatusUseCaseImpl,
} from "../../domain/usecase/payment/status/UseCase";
import {
  PlayerAddToGamesUseCase,
  PlayerAddToGamesUseCaseImpl,
} from "../../domain/usecase/player/AddToGames/AddToGamesUseCase";
import {
  PlayerAddToHistoryUseCase,
  PlayerAddToHistoryUseCaseImpl,
} from "../../domain/usecase/player/AddToHistory/AddToHistoryUseCase";
import {
  PlayerAddToUnfinishedGamesUseCase,
  PlayerAddToUnfinishedGamesUseCaseImpl,
} from "../../domain/usecase/player/AddToUnfinishedGames/UseCase";
import {
  PlayerDeleteAccountUseCase,
  PlayerDeleteAccountUseCaseImpl,
} from "../../domain/usecase/player/DeleteAccount/UseCase";
import {
  PlayerGameStartedUseCase,
  PlayerGameStartedUseCaseImpl,
} from "../../domain/usecase/player/GameStarted/GameStartedUseCase";
import {
  GetPlayerCategoriesStatsUseCase,
  GetPlayerCategoriesStatsUseCaseImpl,
} from "../../domain/usecase/player/GetCategoriesStats/GetCategoriesStatsUseCase";
import {
  PlayerGetCurrentInfoUseCase,
  PlayerGetCurrentInfoUseCaseImpl,
} from "../../domain/usecase/player/GetCurrentInfo/GetCurrentInfoUseCase";
import {
  PlayerRemoveFromUnfinishedGamesUseCase,
  PlayerRemoveFromUnfinishedGamesUseCaseImpl,
} from "../../domain/usecase/player/RemoveFromUnfinishedGames/UseCase";
import {
  PlayerResetQuestionsUseCase,
  PlayerResetQuestionsUseCaseImpl,
} from "../../domain/usecase/player/ResetQuestions/ResetQuestionsUseCase";
import {
  UpdatePlayerUseCase,
  UpdatePlayerUseCaseImpl,
} from "../../domain/usecase/player/Update/UpdateUseCase";
import { GenerateQRCodeUseCase, GenerateQRCodeUseCaseImpl } from "../../domain/usecase/qrcode/generate/UseCase";
import {
  GetNumberOfRemainingQuestionsUseCase,
  GetNumberOfRemainingQuestionsUseCaseImpl,
} from "../../domain/usecase/question/getNumberOfRemainingQuestions/GetNumberOfRemainingQuestionsUseCase";
import {
  GetRandomQuestionUseCase,
  GetRandomQuestionUseCaseImpl,
} from "../../domain/usecase/question/getRandomQuestion/GetRandomQuestionUseCase";
import {
  QuestionGiveAnswerUseCase,
  QuestionGiveAnswerUseCaseImpl,
} from "../../domain/usecase/question/giveAnswer/QuestionGiveAnswerUseCase";
import {
  QuestionGiveRatingUseCase,
  QuestionGiveRatingUseCaseImpl,
} from "../../domain/usecase/question/giveRating/QuestionGiveRatingUseCase";
import {
  CreateTransactionUseCase,
  CreateTransactionUseCaseImpl,
} from "../../domain/usecase/transaction/create/CreateUseCase";
import {
  GetAllTransactionsUseCase,
  GetAllTransactionsUseCaseImpl,
} from "../../domain/usecase/transaction/getAll/GetAllUseCase";
import {
  UploadFileUseCase,
  UploadFileUseCaseImpl,
} from "../../domain/usecase/uploadFile/UploadFileUseCase";
import { provideApiBuilder } from "./NetworkModule";

function provideNetworkApi(): NetworkApi {
  return new NetworkApiImpl(provideApiBuilder());
}

// auth
function provideAuthRepository(): AuthRepository {
  return new AuthRepositoryImpl(provideNetworkApi());
}
export function provideLoginUseCase(): LoginUseCase {
  return new LoginUseCaseImpl(provideAuthRepository());
}
export function provideSignupUseCase(): SignupUseCase {
  return new SignupUseCaseImpl(provideAuthRepository());
}
export function provideLoginAsGuestUseCase(): LoginAsGuestUseCase {
  return new LoginAsGuestUseCaseImpl(provideAuthRepository());
}
export function provideLoginByUIDUseCase(): LoginByUIDUseCase {
  return new LoginByUIDUseCaseImpl(provideAuthRepository());
}
export function provideForgotPasswordUseCase(): ForgotPasswordUseCase {
  return new ForgotPasswordUseCaseImpl(provideAuthRepository());
}
export function provideResetPasswordUseCase(): ResetPasswordUseCase {
  return new ResetPasswordUseCaseImpl(provideAuthRepository());
}
export function provideSendVerificationCodeUseCase(): SendVerificationCodeUseCase {
  return new SendVerificationCodeUseCaseImpl(provideAuthRepository());
}
export function provideCheckVerificationCodeUseCase(): CheckVerificationCodeUseCase {
  return new CheckVerificationCodeUseCaseImpl(provideAuthRepository());
}

// upload file
function provideUploadImageRepository(): UploadFileRepository {
  return new UploadFileRepositoryImpl(provideNetworkApi());
}
export function provideUploadFileUseCase(): UploadFileUseCase {
  return new UploadFileUseCaseImpl(provideUploadImageRepository());
}

// player
function providePlayerRepository(): PlayerRepository {
  return new PlayerRepositoryImpl(provideNetworkApi());
}
export function providePlayerGetCurrentInfoUseCase(): PlayerGetCurrentInfoUseCase {
  return new PlayerGetCurrentInfoUseCaseImpl(providePlayerRepository());
}
export function provideUpdatePlayerUseCase(): UpdatePlayerUseCase {
  return new UpdatePlayerUseCaseImpl(providePlayerRepository());
}
export function providePlayerAddToHistoryUseCase(): PlayerAddToHistoryUseCase {
  return new PlayerAddToHistoryUseCaseImpl(providePlayerRepository());
}
export function providePlayerAddToGamesUseCase(): PlayerAddToGamesUseCase {
  return new PlayerAddToGamesUseCaseImpl(providePlayerRepository());
}
export function providePlayerGameStartedUseCase(): PlayerGameStartedUseCase {
  return new PlayerGameStartedUseCaseImpl(providePlayerRepository());
}
export function providePlayerResetQuestionsUseCase(): PlayerResetQuestionsUseCase {
  return new PlayerResetQuestionsUseCaseImpl(providePlayerRepository());
}
export function providePlayerAddToUnfinishedGamesUseCase(): PlayerAddToUnfinishedGamesUseCase {
  return new PlayerAddToUnfinishedGamesUseCaseImpl(providePlayerRepository());
}
export function providePlayerRemoveFromUnfinishedGamesUseCase(): PlayerRemoveFromUnfinishedGamesUseCase {
  return new PlayerRemoveFromUnfinishedGamesUseCaseImpl(
    providePlayerRepository()
  );
}
export function providePlayerDeleteAccountUseCase(): PlayerDeleteAccountUseCase {
  return new PlayerDeleteAccountUseCaseImpl(providePlayerRepository());
}
export function provideGetPlayerCategoriesStatsUseCase(): GetPlayerCategoriesStatsUseCase {
  return new GetPlayerCategoriesStatsUseCaseImpl(providePlayerRepository());
}

// category
function provideCategoryRepository(): CategoryRepository {
  return new CategoryRepositoryImpl(provideNetworkApi());
}
export function provideGetAllCategoriesUseCase(): GetAllCategoriesUseCase {
  return new GetAllCategoriesUseCaseImpl(provideCategoryRepository());
}
export function provideUnlockCategoryUseCase(): UnlockCategoryUseCase {
  return new UnlockCategoryUseCaseImpl(provideCategoryRepository());
}
export function provideGetCategoryUnlockCodeUseCase(): GetCategoryUnlockCodeUseCase {
  return new GetCategoryUnlockCodeUseCaseImpl(provideCategoryRepository());
}

// question
function provideQuestionRepository(): QuestionRepository {
  return new QuestionRepositoryImpl(provideNetworkApi());
}
export function provideGetNumberOfRemainingQuestionsUseCase(): GetNumberOfRemainingQuestionsUseCase {
  return new GetNumberOfRemainingQuestionsUseCaseImpl(
    provideQuestionRepository()
  );
}
export function provideGetRandomQuestionUseCase(): GetRandomQuestionUseCase {
  return new GetRandomQuestionUseCaseImpl(provideQuestionRepository());
}
export function provideQuestionGiveRatingUseCase(): QuestionGiveRatingUseCase {
  return new QuestionGiveRatingUseCaseImpl(provideQuestionRepository());
}
export function provideQuestionGiveAnswerUseCase(): QuestionGiveAnswerUseCase {
  return new QuestionGiveAnswerUseCaseImpl(provideQuestionRepository());
}

// answer
function provideAnswerRepository(): AnswerRepository {
  return new AnswerRepositoryImpl(provideNetworkApi());
}
export function provideGetAnswerByQuestionIdUseCase(): GetAnswerByQuestionIdUseCase {
  return new GetAnswerByQuestionIdUseCaseImpl(provideAnswerRepository());
}
export function provideGetAnswerUseCase(): GetAnswerUseCase {
  return new GetAnswerUseCaseImpl(provideAnswerRepository());
}

// qrcode
function provideQRCodeRepository(): QRCodeRepository {
  return new QRCodeRepositoryImpl(provideNetworkApi());
}
export function provideGenerateQRCodeUseCase(): GenerateQRCodeUseCase {
  return new GenerateQRCodeUseCaseImpl(provideQRCodeRepository());
}

// package
function providePackageRepository(): PackageRepository {
  return new PackageRepositoryImpl(provideNetworkApi());
}
export function provideGetAllPackagesUseCase(): GetAllPackagesUseCase {
  return new GetAllPackagesUseCaseImpl(providePackageRepository());
}

// payment
function providePaymentRepository(): PaymentRepository {
  return new PaymentRepositoryImpl(provideNetworkApi());
}
export function provideInitiatePaymentUseCase(): InitiatePaymentUseCase {
  return new InitiatePaymentUseCaseImpl(providePaymentRepository());
}
export function provideExecutePaymentUseCase(): ExecutePaymentUseCase {
  return new ExecutePaymentUseCaseImpl(providePaymentRepository());
}
export function provideGetPaymentStatusUseCase(): GetPaymentStatusUseCase {
  return new GetPaymentStatusUseCaseImpl(providePaymentRepository());
}

// discount code
function provideDiscountCodeRepository(): DiscountCodeRepository {
  return new DiscountCodeRepositoryImpl(provideNetworkApi());
}
export function provideCheckDiscountCodeIfRedeemableUseCase(): CheckDiscountCodeIfRedeemableUseCase {
  return new CheckDiscountCodeIfRedeemableUseCaseImpl(
    provideDiscountCodeRepository()
  );
}
export function provideRedeemDicountCodeUseCase(): RedeemDiscountCodeUseCase {
  return new RedeemDiscountCodeUseCaseImpl(provideDiscountCodeRepository());
}

// game
function provideGameRepository(): GameRepository {
  return new GameRepositoryImpl(provideNetworkApi());
}
export function provideUpdateGameUseCase(): UpdateGameUseCase {
  return new UpdateGameUseCaseImpl(provideGameRepository());
}

// transaction
function provideTransactionRepository(): TransactionRepository {
  return new TransactionRepositoryImpl(provideNetworkApi());
}
export function provideCreateTransactionUseCase(): CreateTransactionUseCase {
  return new CreateTransactionUseCaseImpl(provideTransactionRepository());
}
export function provideGetAllTransactionsUseCase(): GetAllTransactionsUseCase {
  return new GetAllTransactionsUseCaseImpl(provideTransactionRepository());
}
